<template>
  <el-dialog :visible.sync="visible" :title="!dataForm.id ? $t('add') : $t('update')" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()" :label-width="$i18n.locale === 'en-US' ? '120px' : '80px'">
          <el-form-item label="请求ip" prop="requestIp">
          <el-input v-model="dataForm.requestIp" placeholder="请求ip"></el-input>
      </el-form-item>
          <el-form-item label="手机号" prop="requestMobile">
          <el-input v-model="dataForm.requestMobile" placeholder="手机号"></el-input>
      </el-form-item>
          <el-form-item label="标识符" prop="requestMark">
          <el-input v-model="dataForm.requestMark" placeholder="标识符"></el-input>
      </el-form-item>
              <el-form-item label="是否白名单(1是，0否)" prop="whitelist">
          <el-input v-model="dataForm.whitelist" placeholder="是否白名单(1是，0否)"></el-input>
      </el-form-item>
          <el-form-item label="公司名称" prop="companyName">
          <el-input v-model="dataForm.companyName" placeholder="公司名称"></el-input>
      </el-form-item>
      </el-form>
    <template slot="footer">
      <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>
    </template>
  </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'
export default {
  data () {
    return {
      visible: false,
      dataForm: {
        id: '',
        requestIp: '',
        requestMobile: '',
        requestMark: '',
        creator: '',
        createDate: '',
        whitelist: '',
        companyName: ''
      }
    }
  },
  computed: {
    dataRule () {
      return {
        requestIp: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        requestMobile: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        requestMark: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        whitelist: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        companyName: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    init () {
      this.visible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].resetFields()
        if (this.dataForm.id) {
          this.getInfo()
        }
      })
    },
    // 获取信息
    getInfo () {
      this.$http.get(`/sys/deduplicationiplog/${this.dataForm.id}`).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.dataForm = {
          ...this.dataForm,
          ...res.data
        }
      }).catch(() => {})
    },
    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        this.$http[!this.dataForm.id ? 'post' : 'put']('/sys/deduplicationiplog/', this.dataForm).then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.visible = false
              this.$emit('refreshDataList')
            }
          })
        }).catch(() => {})
      })
    }, 1000, { 'leading': true, 'trailing': false })
  }
}
</script>
